import { render, staticRenderFns } from "./OurBrands.vue?vue&type=template&id=78b80f34&scoped=true"
import script from "./OurBrands.vue?vue&type=script&lang=js"
export * from "./OurBrands.vue?vue&type=script&lang=js"
import style0 from "./OurBrands.vue?vue&type=style&index=0&id=78b80f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b80f34",
  null
  
)

export default component.exports